import {contexts} from '@/store/context'

export default function (context = contexts.POISSONNERIE_CONTEXT) {
  const defaultHublotBackend = 'https://api.hublot.io/'
  const defaultCarnotBackend = 'https://api.carnot.hublot.io/'

  const currentBackend = (() => {
    if (context === contexts.BOUCHERIE_CONTEXT) return defaultCarnotBackend
    return defaultHublotBackend
  })()

  const chatBackend = (() => {
    if (context === contexts.BOUCHERIE_CONTEXT) return 'https://api.carnot.hublot.io/'
    return 'https://api.hublot.io/'
  })()

  const hygieneApi = (() => {
    if (context === contexts.BOUCHERIE_CONTEXT) return defaultCarnotBackend
    return defaultHublotBackend
  })()

  const objectifApi = (() => {
    if (context === contexts.POISSONNERIE_CONTEXT) return 'https://api.hublot.io/'
    return 'https://api.carnot.hublot.io/'
  })()
  const eventApi = (() => {
    if (context === contexts.POISSONNERIE_CONTEXT) return 'https://api.hublot.io/objectifs/'
    return 'https://api.carnot.hublot.io/objectifs/'
  })()

  const factureApi = (() => {
    if (context === contexts.BOUCHERIE_CONTEXT) return 'https://api.carnot.hublot.io/facture/'
    return `${defaultHublotBackend}facture/`
  })()

  const integrationManagementServiceApi = (() => {
    if (context === contexts.BOUCHERIE_CONTEXT) return 'https://api.carnot.hublot.io/'
    return `https://api.hublot.io/`
  })()

  const erpSettingsApi = (() => {
    if (context === contexts.BOUCHERIE_CONTEXT) return 'https://api.carnot.hublot.io/'
    return 'https://api.hublot.io/'
  })()


  return {
    weatherAppId: '5d0f38a5515afed06983766634ab898e',
    meteoUrl: 'https://api.open-meteo.com/v1/forecast',
    meteoArchiveUrl: 'https://archive-api.open-meteo.com/v1/archive',
    geolocUrl: 'https://geocoding-api.open-meteo.com/v1/search',
    excelService: `${defaultHublotBackend}excel/export`,
    cadencierService: `${defaultHublotBackend}cadencier`,
    simulateurService: `${defaultHublotBackend}simulateur`,
    predictionService: `${defaultHublotBackend}prediction`,
    etiquetteService: `${currentBackend}eprint`,
    clientService: `${currentBackend}client`,
    hygieneService: `${hygieneApi}hygiene`,
    venteService: 'https://api.hublot.io/erp-export-api',
    erpApiService: `https://api.hublot.io/erp-integration`,
    tracabiliteService: `${currentBackend}image`,
    achatService: `${defaultHublotBackend}factures`,
    factureService: `${factureApi}`,
    typeFactureService: `${factureApi}typeFacture`,
    stockService: `${factureApi}stock`,
    fournisseurService: `${factureApi}fournisseur`,
    erpImportService: `${integrationManagementServiceApi}erp-import-upload`,
    integrationManagementService: `${currentBackend}integration-management`,
    notilusService: `https://api.hublot.io/notilus`,
    pdfService: `https://api.hublot.io/pdf/generate`,
    databaseUrl: `${currentBackend}database`,
    fishService: `${currentBackend}fish`,
    mailService: `https://api.hublot.io/mail-sender`,
    imagePdfService: `https://api.hublot.io/pdf/image`,
    commandeService: `${currentBackend}commandes`,
    objectifService: `${objectifApi}objectifs`,
    objectifLegacyService: `${defaultHublotBackend}objectif`,
    eventCalendarService: `${eventApi}customEvents`,
    backlogService: `${defaultHublotBackend}info`,
    remarquesService: `${defaultHublotBackend}remarques`,
    syncService: 'https://api.hublot.io/synchronization',
    erpSettings: `${erpSettingsApi}erp-settings`,
    chatService: chatBackend,
    chatImageApi: `${currentBackend}chat/v2/image/`,
    keycloakAuthBackend: `${currentBackend}keycloak-auth/`
  }
}
